import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.625 16.5C7.475 16.5 6.5 16.1 5.7 15.3C4.9 14.5 4.5 13.525 4.5 12.375V4.5C4.5 3.675 4.79375 2.96875 5.38125 2.38125C5.96875 1.79375 6.675 1.5 7.5 1.5C8.325 1.5 9.03125 1.79375 9.61875 2.38125C10.2062 2.96875 10.5 3.675 10.5 4.5V10.5H9.375V4.5C9.375 3.975 9.19375 3.53125 8.83125 3.16875C8.46875 2.80625 8.025 2.625 7.5 2.625C6.975 2.625 6.53125 2.80625 6.16875 3.16875C5.80625 3.53125 5.625 3.975 5.625 4.5V12.375C5.625 13.2 5.91875 13.9063 6.50625 14.4938C7.09375 15.0813 7.8 15.375 8.625 15.375C8.9875 15.375 9.32825 15.3155 9.64725 15.1965C9.96575 15.078 10.25 14.9125 10.5 14.7V16.05C10.2125 16.1875 9.9125 16.2968 9.6 16.3778C9.2875 16.4592 8.9625 16.5 8.625 16.5ZM12 15.75V13.5H9.75V12H12V9.75H13.5V12H15.75V13.5H13.5V15.75H12ZM8.625 12.375V13.5C8.1 13.5 7.65625 13.3187 7.29375 12.9562C6.93125 12.5938 6.75 12.15 6.75 11.625V4.5H7.875V11.625C7.875 11.8375 7.947 12.0155 8.091 12.159C8.2345 12.303 8.4125 12.375 8.625 12.375ZM11.625 8.25V4.5H12.75V8.25H11.625Z",
      fill: "#7561EC"
    }, null, -1)
  ]))]))
}
export default { render: render }